import React from 'react';
import PingStatus from './PingStatus'
import Checks from './Checks'
import { Glyphicon, Button } from 'react-bootstrap'

class ServiceItem extends React.Component {
    onPing = () => {
        this.props.onPing(this.props.serviceName);
    }

    render() {
        return (
            <tr>
                <td>
                    {this.props.serviceName}<br />
                    <small><a href={this.props.url} target="_blank">{this.props.url}</a></small>
                </td>
                <td>
                    {this.props.serverName}<br />
                    <small>{this.props.startupDate}</small>
                </td>
                <td>
                    {this.props.environmentCode}<br />
                    <small>{this.props.version}</small>
                </td>
                <td>
                    <Checks processing={this.props.processing} checks={this.props.checks} />
                </td>
                <td>
                    <PingStatus processing={this.props.processing} pingError={this.props.pingError} />
                </td>
                <td>
                    <Button bsSize="xsmall" onClick={this.onPing}><Glyphicon glyph="play" /> Ping</Button>
                </td>
            </tr>
        );
    }
}

export default ServiceItem;


// WEBPACK FOOTER //
// ./src/areas/admin/console/services/ServiceItem.js